import { IconModule } from './../icon/icon.module';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SnackbarComponent } from "./snackbar.component";
import { ProgressbarModule } from "../progressbar/progressbar.module";
import { TransitionModule } from "../transition/index";
import { CardModule } from "../card/card.module";
import { SnackbarContainerComponent } from "./snackbar-container/snackbar-container.component";

@NgModule({
	declarations: [SnackbarComponent, SnackbarContainerComponent],
	imports: [CommonModule, TransitionModule, ProgressbarModule, CardModule, IconModule],
	exports: [SnackbarComponent, SnackbarContainerComponent]
})
export class SnackbarModule { }
